const normalizeHost = (value: string | undefined | null): string => {
  const trimmed = typeof value === 'string' ? value.trim() : '';
  return trimmed.replace(/\/+$/, '');
};

export const API_HOST = normalizeHost(import.meta.env.VITE_API_URL);
